import React from "react";

/**
 * A group's final feedback, added up (30.10.2026): for the trainer after
 * closing and from 3 answers, for the team at any time. Never who said what.
 */
export default function FeedbackResults({ results, people }) {
  if (!results) return null;
  const n = results.answered || 0;
  const signed = results.nps == null ? "—" : `${results.nps > 0 ? "+" : ""}${results.nps}`;
  return (
    <div className="grid gap-5" data-testid="feedback-results">
      <div>
        <h3 className="font-display text-base font-bold text-[#373A45]">
          Ce au spus cursanții · {n === 1 ? "un răspuns" : `${n} răspunsuri`}{people ? ` din ${people}` : ""}
        </h3>
        <p className="mt-0.5 text-sm text-[#6B7280]">Răspunsurile sunt anonime și adunate pe grupă.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-xl bg-[#F5F6F6] px-4 py-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-[#6B7280]">Recomandarea (8)</p>
          <p className="mt-1 text-sm text-[#373A45]">
            Scorul de recomandare (NPS): <strong className="text-lg tabular-nums">{signed}</strong>
          </p>
          <p className="text-xs text-[#6B7280]">
            {results.promoters} recomandă, {results.passives} {results.passives === 1 ? "neutru" : "neutri"}, {results.detractors} nu recomandă
          </p>
        </div>
        <div className="rounded-xl bg-[#F5F6F6] px-4 py-3">
          <p className="text-xs font-semibold uppercase tracking-wide text-[#6B7280]">Mulțumirea (1)</p>
          <p className="mt-1 text-sm text-[#373A45]">
            În medie <strong className="text-lg tabular-nums">{results.satisfaction == null ? "—" : String(results.satisfaction).replace(".", ",")}</strong> din 10
          </p>
        </div>
      </div>
      <div className="grid gap-4">
        {(results.questions || []).map((q) => (
          <div key={q.id}>
            <p className="text-sm font-semibold text-[#373A45]">{q.n}. {q.label}</p>
            <ul className="mt-2 grid gap-1">
              {q.options.map((o) => (
                <li key={o.key} className="grid grid-cols-[minmax(0,12rem)_1fr_2rem] items-center gap-2 text-xs text-[#373A45]">
                  <span className="truncate" title={o.label}>{o.label}</span>
                  <span className="h-2 rounded-full bg-[#F5F6F6]">
                    <span className="block h-2 rounded-full bg-[#965EA7]" style={{ width: n ? `${(100 * o.count) / n}%` : 0 }} />
                  </span>
                  <span className="text-right tabular-nums text-[#6B7280]">{o.count}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {(results.improve || []).length > 0 && (
        <div>
          <p className="text-sm font-semibold text-[#373A45]">9. Ce ar îmbunătăți</p>
          <ul className="mt-2 grid gap-2">
            {results.improve.map((t, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={i} className="whitespace-pre-line rounded-xl bg-[#F5F6F6] px-4 py-2.5 text-sm text-[#373A45]">{t}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
